<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component components/budget-info/budget-info.component.ts
-->
<ng-template #anchor></ng-template>
